// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__MOtoA","row":"styles_row__3yM0B"};